import { Layout, Skeleton } from "../../components/ui";
import { useDeleteNotification, useGetNotificationById } from "../../query/notificationQuery";
import { useNavigate, useParams } from "react-router-dom";
import swal from "../../utils/swal";
import NotificationProfile from "./NotificationProfile";

function NotificationDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isLoading, data: notification } = useGetNotificationById(id);
  const { mutate: deleteNotification } = useDeleteNotification();

  const handleDelete = () => {
    swal({
      title: "Recall this notice?",
      text: "It will be removed from every parent and teacher app. This cannot be undone.",
      icon: "warning",
      buttons: ["Keep notice", "Recall notice"],
      dangerMode: true,
    }).then((isConfirm) => {
      if (!isConfirm) return;
      deleteNotification(id, {
        onSuccess: () => {
          swal("Recalled", "Notice removed from all users", "success");
          navigate("/notifications");
        },
        onError: (error) => {
          swal("Cannot recall", error?.message || "Failed to recall notice", "error");
        },
      });
    });
  };

  return (
    <Layout className="configuration">
      <div className="boxDetails" style={{ background: "transparent", padding: 0, boxShadow: "none" }}>
        {isLoading && (
          <div style={{ display: "flex", justifyContent: "center", padding: "40px 0" }}>
            <Skeleton active paragraph={{ rows: 10 }} />
          </div>
        )}

        {!isLoading && notification && (
          <NotificationProfile notification={notification} onDelete={handleDelete} />
        )}
      </div>
    </Layout>
  );
}

export default NotificationDetails;
